import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Layout from '../components/Layout'
import Home from '../container/Home'
import Extra from '../container/Extra'
import Skills from '../container/Skills'
import Projects from '../container/Projects'
import Contact from '../container/Contact'
import Project from '../container/Project'
import { createGlobalStyle, keyframes } from "styled-components"
const fadeIn = keyframes`
0% {
   bottom: -100%;
      }
      
      100% {
      
        bottom: 0%;
      }
`;
const fadeInM = keyframes`
0% {
   right: -100%;
      }
      
      100% {
      
        right: 0%;
      }
`;
const GlobalStyle = createGlobalStyle`
@media (max-width: 415px){section{
  animation:${fadeIn} 2s ;
  overflow-y: scroll;
  overflow-x:none;
}}
@media (min-width: 415.1px){section{
  animation:${fadeInM} 2s ;
  overflow-y: scroll;
  overflow-x:none;
}}

  body {
    background-color: #273136;
    margin:0;
    padding:0;
    height:100vh;
    width:100%;
    position: relative;
    overflow: hidden;
    font-family: 'Nunito', sans-serif;
  }
`
const App =()=>{

return (

    <BrowserRouter>
    <Layout>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/skills" component={Skills} />
        <Route exact path="/projects" component={Projects} />
        <Route exact path="/projects" component={Projects} />
        <Route exact path="/projects/:id" component={Project} />
        <Route exact path="/contact" component={Contact} />
        <Route exact path="/extra" component={Extra} />
        {/* <Route component={NotFound} /> */}
      </Switch>
    </Layout>
    <GlobalStyle/>
  </BrowserRouter>

)


}
export default App